import { UserType } from '@avanta/shared/constants/users';
import { type AdminRole } from '@avanta/shared/types/enterprises';
import { getRefreshToken } from '@avanta/shared/utils/storage';
import { type ReactNode } from 'react';
import { Navigate, Outlet } from 'react-router';
import { ROUTES } from 'constants/routes';
import { useUserStore } from 'stores/user';

export const ProtectedRoute = ({ allowedRoles }: { allowedRoles?: AdminRole[] }): ReactNode => {
  const refreshToken = getRefreshToken();
  const user = useUserStore(state => state.user);

  if (!refreshToken) {
    return <Navigate to={ROUTES.LOGIN} />;
  }

  if (location.pathname === ROUTES.ROOT) {
    return <Navigate to={ROUTES.HOME} />;
  }

  const hasAccess =
    user?.type === UserType.ENTERPRISE ||
    (user?.type === UserType.ADMIN_ENTERPRISE &&
      (!allowedRoles || allowedRoles.includes(user.role)));

  if (user && !hasAccess) {
    return <Navigate to={ROUTES.HOME} />;
  }

  return <Outlet />;
};
